import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '~/components/FormControl';
import { useField } from 'formik';
import { titleCase } from '~/utils/helpers';
import camelCase from 'lodash/camelCase';
import { Row } from 'react-bootstrap';

function CheckboxGroup({ options, fieldName, sm, className, isMultiple }) {
    const [, meta, helpers] = useField(fieldName);

    let fieldValues;

    if (isMultiple) {
        fieldValues = meta.value ? [...meta.value] : [];
    } else {
        fieldValues = meta.value ?? '';
    }

    const handleChangeMultiple = (id) => {
        if (fieldValues.includes(id)) {
            const filtered = fieldValues.filter(function (value) {
                return value !== id;
            });
            fieldValues = filtered;
        } else {
            fieldValues.push(id);
        }

        fieldValues.sort();
        helpers.setValue(fieldValues, true); //as I set 'validateOnChange' = false, so need to specify `shouldValidate` = true so that validation can be executed upon checking the box. Ref: https://formik.org/docs/api/useField#fieldhelperprops
    };

    const handleChangeSingle = (id) => {
        helpers.setValue(id, true);
    };

    return (
        <Row className={className}>
            {options.length > 0 &&
                options.map((option, i) => (
                    <Checkbox
                        label={titleCase(option.name)}
                        key={i}
                        id={camelCase(option.name)}
                        handleChange={() =>
                            isMultiple ? handleChangeMultiple(option.id) : handleChangeSingle(option.id)
                        }
                        checked={fieldValues.includes(option.id)}
                        width="20px"
                        height="20px"
                        meta={meta}
                        sm={sm}
                    />
                ))}
        </Row>
    );
}

CheckboxGroup.defaultProps = {
    className: null,
    sm: null,
    isMultiple: true,
};

CheckboxGroup.propTypes = {
    options: PropTypes.array.isRequired,
    fieldName: PropTypes.string.isRequired,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    isMultiple: PropTypes.bool,
};
export default CheckboxGroup;
